// extracted by mini-css-extract-plugin
export default {"label":"usage-guide-info-modal_label__-CV6P","time":"usage-guide-info-modal_time__NVLl1","overflowDeviceList":"usage-guide-info-modal_overflowDeviceList__IT9CU"};